/**
 * Badge integration constants.
 * Provider-agnostic design - add new providers by extending PROVIDER_TYPES.
 */

export const PROVIDER_TYPES = {
  ACCREDIBLE: 'accredibleapiconfig',
  CREDLY: 'credlyorganization'
};

export const PROVIDER_LABELS = {
  [PROVIDER_TYPES.ACCREDIBLE]: 'Accredible',
  [PROVIDER_TYPES.CREDLY]: 'Credly'
};

export const badgesConstants = {
  FETCH_BADGE_CONFIGS_REQUEST: 'FETCH_BADGE_CONFIGS_REQUEST',
  FETCH_BADGE_CONFIGS_SUCCESS: 'FETCH_BADGE_CONFIGS_SUCCESS',
  FETCH_BADGE_CONFIGS_FAILURE: 'FETCH_BADGE_CONFIGS_FAILURE',
  FETCH_BADGE_GROUPS_REQUEST: 'FETCH_BADGE_GROUPS_REQUEST',
  FETCH_BADGE_GROUPS_SUCCESS: 'FETCH_BADGE_GROUPS_SUCCESS',
  FETCH_BADGE_GROUPS_FAILURE: 'FETCH_BADGE_GROUPS_FAILURE',
  CLEAR_BADGE_DATA: 'CLEAR_BADGE_DATA'
};

export const badgesDispatches = {
  fetchBadgeConfigsRequest: () => ({ type: badgesConstants.FETCH_BADGE_CONFIGS_REQUEST }),
  fetchBadgeConfigsSuccess: (configs) => ({ type: badgesConstants.FETCH_BADGE_CONFIGS_SUCCESS, payload: configs }),
  fetchBadgeConfigsFailure: (error) => ({ type: badgesConstants.FETCH_BADGE_CONFIGS_FAILURE, error }),
  fetchBadgeGroupsRequest: () => ({ type: badgesConstants.FETCH_BADGE_GROUPS_REQUEST }),
  fetchBadgeGroupsSuccess: (groups) => ({ type: badgesConstants.FETCH_BADGE_GROUPS_SUCCESS, payload: groups }),
  fetchBadgeGroupsFailure: (error) => ({ type: badgesConstants.FETCH_BADGE_GROUPS_FAILURE, error }),
  clearBadgeData: () => ({ type: badgesConstants.CLEAR_BADGE_DATA })
};

// Event type for badge requirements
export const BADGE_EVENT_TYPE = 'org.openedx.learning.course.passing.status.updated.v1';
